import React from 'react';

import FrontEnd from '../../assets/frontend.png';
import BackEnd from '../../assets/backend.png';
import PriceGetter from '../../assets/PriceGetter.png';
import Native from '../../assets/native.jpg';
import ChatAppFrontEnd from '../../assets/chatapp-frontend.png';
import ChatAppBackEnd from '../../assets/chatapp-backend.png';

import './portfolio.css';

const Portfolio = () => {
  const projects = [
    {
      title: 'PriceGetter',
      image: FrontEnd,
      github: 'https://github.com/danialsyed66/PriceGetterFrontend',
      demo: 'https://price-getter.netlify.app/',
      padding: 'pt-4',
    },
    {
      title: 'PriceGetter Backend',
      image: BackEnd,
      github: 'https://github.com/danialsyed66/PriceGetterBackend',
      demo: 'https://price-getter-backend.herokuapp.com/',
      padding: 'pt-4',
    },
    {
      title: 'PriceGetter Scrapper',
      image: PriceGetter,
      github: 'https://github.com/danialsyed66/PriceGetterScraper',
    },
    {
      title: 'PriceGetter ReactNative',
      image: Native,
      github: 'https://github.com/danialsyed66/PriceGetterNative',
      demo: 'https://expo.dev/@danialsyed66/PriceGetterNative',
    },
    {
      title: 'ChatApp TypeScript',
      image: ChatAppFrontEnd,
      github: 'https://github.com/danialsyed66/ChatAppFrontend',
      demo: 'https://chatapp-ts.netlify.app',
    },
    {
      title: 'ChatAppBackend TypeScript',
      image: ChatAppBackEnd,
      github: 'https://github.com/danialsyed66/ChatAppBackend',
      demo: 'https://chatapp-ts-backend.herokuapp.com',
    },
  ];

  const renderProject = ({ title, image, github, demo, padding }, i) => (
    <article className="portfolio__item" key={i}>
      <div className={`portfolio__item-image ${padding}`}>
        <img src={image} alt={title} />
      </div>
      <h3>{title}</h3>
      <div className="portfolio__item-cta">
        <a href={github} className="btn" target="_blank" rel="noreferrer">
          GitHub
        </a>
        {demo && (
          <a
            href={demo}
            className="btn btn-primary"
            target="_blank"
            rel="noreferrer"
          >
            Demo
          </a>
        )}
      </div>
    </article>
  );

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Protfolio</h2>
      <div className="container portfolio__container">
        {projects.map((project, i) => renderProject(project, i))}
      </div>
    </section>
  );
};

export default Portfolio;
